import { ICompareFlightTooltipState } from '../../types/redux';

const initialState: ICompareFlightTooltipState = {
  isCompareFlightTooltipShow: false,
};

export function compareFlightTooltipReducer(state = initialState): ICompareFlightTooltipState {
  return state;
}
